export class CouponValidity {
    constructor (
        public CouponCode : string = '',
        public Valid : boolean = false,
        public ErrorText : string = '',
        public SuccessText: string = ''
    ) {}
}
